import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningApiService } from 'src/services/aiListeningApi'

export const useGetAiListeningCampaignsQuery = () => {
  return useQuery({
    queryFn: () => AiListeningApiService.getList(),
    queryKey: [QueryKey.GET_AI_LISTENING_CAMPAIGNS],
  })
}
